var EPaddleCountryValueGerman = /*#__PURE__*/function (EPaddleCountryValueGerman) {
  EPaddleCountryValueGerman["Afghanistan"] = "Afghanistan";
  EPaddleCountryValueGerman["AlandIslands"] = "Aland-Inseln";
  EPaddleCountryValueGerman["Albania"] = "Albanien";
  EPaddleCountryValueGerman["Algeria"] = "Algerien";
  EPaddleCountryValueGerman["AmericanSamoa"] = "Amerikanisch-Samoa";
  EPaddleCountryValueGerman["Andorra"] = "Andorra";
  EPaddleCountryValueGerman["Angola"] = "Angola";
  EPaddleCountryValueGerman["Anguilla"] = "Anguilla";
  EPaddleCountryValueGerman["AntiguaandBarbuda"] = "Antigua und Barbuda";
  EPaddleCountryValueGerman["Argentina"] = "Argentinien";
  EPaddleCountryValueGerman["Armenia"] = "Armenien";
  EPaddleCountryValueGerman["Aruba"] = "Aruba";
  EPaddleCountryValueGerman["Australia"] = "Australien";
  EPaddleCountryValueGerman["Austria"] = "\xD6sterreich";
  EPaddleCountryValueGerman["Azerbaijan"] = "Aserbaidschan";
  EPaddleCountryValueGerman["Bahamas"] = "Bahamas";
  EPaddleCountryValueGerman["Bahrain"] = "Bahrain";
  EPaddleCountryValueGerman["Bangladesh"] = "Bangladesch";
  EPaddleCountryValueGerman["Barbados"] = "Barbados";
  EPaddleCountryValueGerman["Belarus"] = "Wei\xDFrussland";
  EPaddleCountryValueGerman["Belgium"] = "Belgien";
  EPaddleCountryValueGerman["Belize"] = "Belize";
  EPaddleCountryValueGerman["Benin"] = "Benin";
  EPaddleCountryValueGerman["Bermuda"] = "Bermuda";
  EPaddleCountryValueGerman["Bhutan"] = "Bhutan";
  EPaddleCountryValueGerman["Bolivia"] = "Bolivien";
  EPaddleCountryValueGerman["BonaireSintEustatiusandSaba"] = "Bonaire, Sint Eustatius und Saba";
  EPaddleCountryValueGerman["BosniaandHerzegovina"] = "Bosnien und Herzegowina";
  EPaddleCountryValueGerman["Botswana"] = "Botsuana";
  EPaddleCountryValueGerman["BouvetIsland"] = "Bouvetinsel";
  EPaddleCountryValueGerman["Brazil"] = "Brasilien";
  EPaddleCountryValueGerman["BritIndianOcean"] = "Brit. Indischer Ozean";
  EPaddleCountryValueGerman["BritishVirginIslands"] = "Britische Jungferninseln";
  EPaddleCountryValueGerman["BruneiDarussalam"] = "Brunei Darussalam";
  EPaddleCountryValueGerman["Bulgaria"] = "Bulgarien";
  EPaddleCountryValueGerman["BurkinaFaso"] = "Burkina Faso";
  EPaddleCountryValueGerman["Burundi"] = "Burundi";
  EPaddleCountryValueGerman["Cambodia"] = "Kambodscha";
  EPaddleCountryValueGerman["Cameroon"] = "Kamerun";
  EPaddleCountryValueGerman["Canada"] = "Kanada";
  EPaddleCountryValueGerman["CapeVerde"] = "Kap Verde";
  EPaddleCountryValueGerman["CaymanIslands"] = "Kaimaninseln";
  EPaddleCountryValueGerman["CentralAfricanRepublic"] = "Zentralafrikanische Republik";
  EPaddleCountryValueGerman["Chad"] = "Tschad";
  EPaddleCountryValueGerman["Chile"] = "Chile";
  EPaddleCountryValueGerman["China"] = "China";
  EPaddleCountryValueGerman["ChristmasIsland"] = "Weihnachtsinsel";
  EPaddleCountryValueGerman["CocosIslands"] = "Kokosinseln";
  EPaddleCountryValueGerman["Colombia"] = "Kolumbien";
  EPaddleCountryValueGerman["Comoros"] = "Komoren";
  EPaddleCountryValueGerman["Congo"] = "Kongo";
  EPaddleCountryValueGerman["CookIslands"] = "Cook-Inseln";
  EPaddleCountryValueGerman["CostaRica"] = "Costa Rica";
  EPaddleCountryValueGerman["CoteDIvoire"] = "Elfenbeink\xFCste";
  EPaddleCountryValueGerman["Croatia"] = "Kroatien";
  EPaddleCountryValueGerman["Cuba"] = "Kuba";
  EPaddleCountryValueGerman["Cura\xE7ao"] = "Cura\xE7ao";
  EPaddleCountryValueGerman["Cyprus"] = "Zypern";
  EPaddleCountryValueGerman["CzechRepublic"] = "Tschechische Republik";
  EPaddleCountryValueGerman["Denmark"] = "D\xE4nemark";
  EPaddleCountryValueGerman["Djibouti"] = "Dschibuti";
  EPaddleCountryValueGerman["Dominica"] = "Dominica";
  EPaddleCountryValueGerman["DominicanRepublic"] = "Dominikanische Republik";
  EPaddleCountryValueGerman["Ecuador"] = "Ecuador";
  EPaddleCountryValueGerman["Egypt"] = "\xC4gypten";
  EPaddleCountryValueGerman["ElSalvador"] = "El Salvador";
  EPaddleCountryValueGerman["EquatorialGuinea"] = "\xC4quatorialguinea";
  EPaddleCountryValueGerman["Eritrea"] = "Eritrea";
  EPaddleCountryValueGerman["Estonia"] = "Estland";
  EPaddleCountryValueGerman["Ethiopia"] = "\xC4thiopien";
  EPaddleCountryValueGerman["FalklandIslands"] = "Falkland-Inseln";
  EPaddleCountryValueGerman["FaroeIslands"] = "F\xE4r\xF6er-Inseln";
  EPaddleCountryValueGerman["Fiji"] = "Fidschi";
  EPaddleCountryValueGerman["Finland"] = "Finnland";
  EPaddleCountryValueGerman["Frankreich"] = "Frankreich";
  EPaddleCountryValueGerman["FrenchGuiana"] = "Franz\xF6sisch-Guayana";
  EPaddleCountryValueGerman["FrenchPolynesia"] = "Franz\xF6sisch-Polynesien";
  EPaddleCountryValueGerman["FrenchSouthernTerr"] = "Franz\xF6sische S\xFCd-Terr";
  EPaddleCountryValueGerman["Gabon"] = "Gabun";
  EPaddleCountryValueGerman["Gambia"] = "Gambia";
  EPaddleCountryValueGerman["Georgia"] = "Georgien";
  EPaddleCountryValueGerman["Germany"] = "Deutschland";
  EPaddleCountryValueGerman["Ghana"] = "Ghana";
  EPaddleCountryValueGerman["Gibraltar"] = "Gibraltar";
  EPaddleCountryValueGerman["Greece"] = "Griechenland";
  EPaddleCountryValueGerman["Greenland"] = "Gr\xF6nland";
  EPaddleCountryValueGerman["Grenada"] = "Grenada";
  EPaddleCountryValueGerman["Guadeloupe"] = "Guadeloupe";
  EPaddleCountryValueGerman["Guam"] = "Guam";
  EPaddleCountryValueGerman["Guatemala"] = "Guatemala";
  EPaddleCountryValueGerman["Guernsey"] = "Guernsey";
  EPaddleCountryValueGerman["Guinea"] = "Guinea";
  EPaddleCountryValueGerman["GuineaBissau"] = "Guinea-Bissau";
  EPaddleCountryValueGerman["Guyana"] = "Guyana";
  EPaddleCountryValueGerman["Haiti"] = "Haiti";
  EPaddleCountryValueGerman["HeardMcdonaldIslands"] = "Heard/Mcdonaldinseln";
  EPaddleCountryValueGerman["HolySeeVaticanCity"] = "Heiliger Stuhl/ Vatikanstadt";
  EPaddleCountryValueGerman["Honduras"] = "Honduras";
  EPaddleCountryValueGerman["HongKong"] = "Hongkong";
  EPaddleCountryValueGerman["Hungary"] = "Ungarn";
  EPaddleCountryValueGerman["Iceland"] = "Island";
  EPaddleCountryValueGerman["India"] = "Indien";
  EPaddleCountryValueGerman["Indonesia"] = "Indonesien";
  EPaddleCountryValueGerman["Iran"] = "Iran";
  EPaddleCountryValueGerman["Iraq"] = "Irak";
  EPaddleCountryValueGerman["Ireland"] = "Irland";
  EPaddleCountryValueGerman["IsleofMan"] = "Isle of Man";
  EPaddleCountryValueGerman["Israel"] = "Israel";
  EPaddleCountryValueGerman["Italy"] = "Italien";
  EPaddleCountryValueGerman["Jamaica"] = "Jamaika";
  EPaddleCountryValueGerman["Japan"] = "Japan";
  EPaddleCountryValueGerman["Jersey"] = "Trikot";
  EPaddleCountryValueGerman["Jordan"] = "Jordanien";
  EPaddleCountryValueGerman["Kazakhstan"] = "Kasachstan";
  EPaddleCountryValueGerman["Kenya"] = "Kenia";
  EPaddleCountryValueGerman["Kiribati"] = "Kiribati";
  EPaddleCountryValueGerman["Kuwait"] = "Kuwait";
  EPaddleCountryValueGerman["Kyrgyzstan"] = "Kirgisistan";
  EPaddleCountryValueGerman["LaoPeoplesDR"] = "Demokratische Volksrepublik Laos";
  EPaddleCountryValueGerman["Latvia"] = "Lettland";
  EPaddleCountryValueGerman["Lebanon"] = "Libanon";
  EPaddleCountryValueGerman["Lesotho"] = "Lesotho";
  EPaddleCountryValueGerman["Liberia"] = "Liberia";
  EPaddleCountryValueGerman["LibyanArabJamahiriya"] = "Libysch-Arabische Dschamahirija";
  EPaddleCountryValueGerman["Liechtenstein"] = "Liechtenstein";
  EPaddleCountryValueGerman["Lithuania"] = "Litauen";
  EPaddleCountryValueGerman["Luxembourg"] = "Luxemburg";
  EPaddleCountryValueGerman["Macao"] = "Macao";
  EPaddleCountryValueGerman["Macedonia"] = "Mazedonien";
  EPaddleCountryValueGerman["Madagascar"] = "Madagaskar";
  EPaddleCountryValueGerman["Malawi"] = "Malawi";
  EPaddleCountryValueGerman["Malaysia"] = "Malaysia";
  EPaddleCountryValueGerman["Maldives"] = "Malediven";
  EPaddleCountryValueGerman["Mali"] = "Mali";
  EPaddleCountryValueGerman["Malta"] = "Malta";
  EPaddleCountryValueGerman["MarshallIslands"] = "Marshall-Inseln";
  EPaddleCountryValueGerman["Martinique"] = "Martinique";
  EPaddleCountryValueGerman["Mauritania"] = "Mauretanien";
  EPaddleCountryValueGerman["Mauritius"] = "Mauritius";
  EPaddleCountryValueGerman["Mayotte"] = "Mayotte";
  EPaddleCountryValueGerman["Mexico"] = "Mexiko";
  EPaddleCountryValueGerman["Micronesia"] = "Mikronesien";
  EPaddleCountryValueGerman["Moldova"] = "Moldawien";
  EPaddleCountryValueGerman["Monaco"] = "Monaco";
  EPaddleCountryValueGerman["Mongolia"] = "Mongolei";
  EPaddleCountryValueGerman["Montenegro"] = "Montenegro";
  EPaddleCountryValueGerman["Montserrat"] = "Montserrat";
  EPaddleCountryValueGerman["Morocco"] = "Marokko";
  EPaddleCountryValueGerman["Mozambique"] = "Mosambik";
  EPaddleCountryValueGerman["Myanmar"] = "Myanmar";
  EPaddleCountryValueGerman["Namibia"] = "Namibia";
  EPaddleCountryValueGerman["Nauru"] = "Nauru";
  EPaddleCountryValueGerman["Nepal"] = "Nepal";
  EPaddleCountryValueGerman["Netherlands"] = "Niederlande";
  EPaddleCountryValueGerman["NetherlandsAntilles"] = "Niederl\xE4ndische Antillen";
  EPaddleCountryValueGerman["NewCaledonia"] = "Neukaledonien";
  EPaddleCountryValueGerman["NewZealand"] = "Neuseeland";
  EPaddleCountryValueGerman["Nicaragua"] = "Nicaragua";
  EPaddleCountryValueGerman["Niger"] = "Niger";
  EPaddleCountryValueGerman["Nigeria"] = "Nigeria";
  EPaddleCountryValueGerman["Niue"] = "Niue";
  EPaddleCountryValueGerman["NorfolkIsland"] = "Norfolkinsel";
  EPaddleCountryValueGerman["NorthKorea"] = "Nordkorea";
  EPaddleCountryValueGerman["NorthernMarianaIslands"] = "N\xF6rdliche Marianen-Inseln";
  EPaddleCountryValueGerman["Norway"] = "Norwegen";
  EPaddleCountryValueGerman["Oman"] = "Oman";
  EPaddleCountryValueGerman["Pakistan"] = "Pakistan";
  EPaddleCountryValueGerman["Palau"] = "Palau";
  EPaddleCountryValueGerman["PalestinianTerritory"] = "Pal\xE4stinensisches Gebiet";
  EPaddleCountryValueGerman["Panama"] = "Panama";
  EPaddleCountryValueGerman["PapuaNewGuinea"] = "Papua-Neuguinea";
  EPaddleCountryValueGerman["Paraguay"] = "Paraguay";
  EPaddleCountryValueGerman["Peru"] = "Peru";
  EPaddleCountryValueGerman["Philippines"] = "Philippinen";
  EPaddleCountryValueGerman["Pitcairn"] = "Pitcairn";
  EPaddleCountryValueGerman["Poland"] = "Polen";
  EPaddleCountryValueGerman["Portugal"] = "Portugal";
  EPaddleCountryValueGerman["PuertoRico"] = "Puerto Rico";
  EPaddleCountryValueGerman["Qatar"] = "Katar";
  EPaddleCountryValueGerman["RepublicofSerbia"] = "Republik Serbien";
  EPaddleCountryValueGerman["Reunion"] = "Wiedersehen";
  EPaddleCountryValueGerman["Romania"] = "Rum\xE4nien";
  EPaddleCountryValueGerman["RussianFederation"] = "Russische F\xF6deration";
  EPaddleCountryValueGerman["Rwanda"] = "Ruanda";
  EPaddleCountryValueGerman["SGeorgiaSandwichIslands"] = "S. Georgien/ Sandwich-Inseln";
  EPaddleCountryValueGerman["SaintHelena"] = "Heilige Helena";
  EPaddleCountryValueGerman["SaintKittsandNevis"] = "St. Kitts und Nevis";
  EPaddleCountryValueGerman["SaintLucia"] = "St. Lucia";
  EPaddleCountryValueGerman["SaintMartin"] = "Sankt Martin";
  EPaddleCountryValueGerman["SaintPierreandMiquelon"] = "Saint-Pierre und Miquelon";
  EPaddleCountryValueGerman["SaintVincentGrenadines"] = "St. Vincent/Grenadinen";
  EPaddleCountryValueGerman["Samoa"] = "Samoa";
  EPaddleCountryValueGerman["SanMarino"] = "San Marino";
  EPaddleCountryValueGerman["SaoTomeandPrincipe"] = "S\xE3o Tom\xE9 und Pr\xEDncipe";
  EPaddleCountryValueGerman["SaudiArabia"] = "Saudi-Arabien";
  EPaddleCountryValueGerman["Senegal"] = "Senegal";
  EPaddleCountryValueGerman["Seychelles"] = "Seychellen";
  EPaddleCountryValueGerman["SierraLeone"] = "Sierra Leone";
  EPaddleCountryValueGerman["Singapore"] = "Singapur";
  EPaddleCountryValueGerman["Slovakia"] = "Slowakei";
  EPaddleCountryValueGerman["Slovenia"] = "Slowenien";
  EPaddleCountryValueGerman["SolomonIslands"] = "Salomon-Inseln";
  EPaddleCountryValueGerman["Somalia"] = "Somalia";
  EPaddleCountryValueGerman["SouthAfrica"] = "S\xFCdafrika";
  EPaddleCountryValueGerman["SouthKorea"] = "S\xFCdkorea";
  EPaddleCountryValueGerman["Spain"] = "Spanien";
  EPaddleCountryValueGerman["SriLanka"] = "Sri Lanka";
  EPaddleCountryValueGerman["Sudan"] = "Sudan";
  EPaddleCountryValueGerman["Suriname"] = "Surinam";
  EPaddleCountryValueGerman["SvalbardandJanMayen"] = "Spitzbergen und Jan Mayen";
  EPaddleCountryValueGerman["Swaziland"] = "Swasiland";
  EPaddleCountryValueGerman["Sweden"] = "Schweden";
  EPaddleCountryValueGerman["Switzerland"] = "Schweiz";
  EPaddleCountryValueGerman["SyrianArabRepublic"] = "Arabische Republik Syrien";
  EPaddleCountryValueGerman["Taiwan"] = "Taiwan";
  EPaddleCountryValueGerman["Tajikistan"] = "Tadschikistan";
  EPaddleCountryValueGerman["Tanzania"] = "Tansania";
  EPaddleCountryValueGerman["Thailand"] = "Thailand";
  EPaddleCountryValueGerman["TimorLeste"] = "Timor-Leste";
  EPaddleCountryValueGerman["Togo"] = "Togo";
  EPaddleCountryValueGerman["Tokelau"] = "Tokelau";
  EPaddleCountryValueGerman["Tonga"] = "Tonga";
  EPaddleCountryValueGerman["TrinidadandTobago"] = "Trinidad und Tobago";
  EPaddleCountryValueGerman["Tunisia"] = "Tunesien";
  EPaddleCountryValueGerman["Turkey"] = "T\xFCrkei";
  EPaddleCountryValueGerman["Turkmenistan"] = "Turkmenistan";
  EPaddleCountryValueGerman["TurksandCaicosIslands"] = "Turks- und Caicosinseln";
  EPaddleCountryValueGerman["Tuvalu"] = "Tuvalu";
  EPaddleCountryValueGerman["USVirginIslands"] = "U.S. Jungferninseln";
  EPaddleCountryValueGerman["Uganda"] = "Uganda";
  EPaddleCountryValueGerman["Ukraine"] = "Ukraine";
  EPaddleCountryValueGerman["UnitedArabEmirates"] = "Vereinigte Arabische Emirate";
  EPaddleCountryValueGerman["UnitedKingdom"] = "Vereinigtes K\xF6nigreich";
  EPaddleCountryValueGerman["UnitedStates"] = "Vereinigte Staaten";
  EPaddleCountryValueGerman["UnitedStatesMOI"] = "Vereinigte Staaten (M.O.I.)";
  EPaddleCountryValueGerman["Uruguay"] = "Uruguay";
  EPaddleCountryValueGerman["Uzbekistan"] = "Usbekistan";
  EPaddleCountryValueGerman["Vanuatu"] = "Vanuatu";
  EPaddleCountryValueGerman["Venezuela"] = "Venezuela";
  EPaddleCountryValueGerman["VietNam"] = "Vietnam";
  EPaddleCountryValueGerman["WallisandFutuna"] = "Wallis und Futuna";
  EPaddleCountryValueGerman["WesternSahara"] = "Westsahara";
  EPaddleCountryValueGerman["Yemen"] = "Jemen";
  EPaddleCountryValueGerman["Zambia"] = "Sambia";
  EPaddleCountryValueGerman["Zimbabwe"] = "Simbabwe";
  return EPaddleCountryValueGerman;
}(EPaddleCountryValueGerman || {});
export { EPaddleCountryValueGerman };